import React, { useEffect, useState } from "react";
import { useStore } from "../../../context";
import { urlMat, urlMatNew } from "../../../utils";
import { httpGet } from "../../../servicios";
import Swal from "sweetalert2";
import "../../../styles/theme.css";

export default function MatriculaList() {
  const { state } = useStore();
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setLoading(true);
    const tipoUserMatricula = JSON.parse(sessionStorage.getItem('login'));
    let urlTemp = urlMat + sessionStorage.getItem("username");
    if (tipoUserMatricula === "N") {
      urlTemp = urlMatNew + sessionStorage.getItem("username");
    }

    httpGet(urlTemp, state.token)
      .then((res) => {
        if (res.cod === 0) {
          if (res.data.error) {
            Swal.fire({ icon: "error", title: "Error", text: "Hubo un error en la consulta", confirmButtonColor: "#0d1b3e" });
            return;
          }
          if (res.data.length === 0) {
            Swal.fire({ icon: "info", title: "Sin resultados", text: "Sin matrículas que mostrar", confirmButtonColor: "#0d1b3e" });
          }
          setRows(res.data);
        } else {
          setRows([]);
          Swal.fire({ icon: "error", title: "Error", text: "Error en la consulta", confirmButtonColor: "#0d1b3e" });
        }
      })
      .catch(() => {
        Swal.fire({ icon: "error", title: "Error", text: "Error fatal con el servidor!", confirmButtonColor: "#0d1b3e" });
      })
      .finally(() => setLoading(false));
  }, [state]);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: 60 }}>
        <div className="modern-spinner"></div>
      </div>
    );
  }

  return (
    <div>
      {/* Header */}
      <div className="modern-card-header" style={{ marginBottom: 20, textAlign: "center" }}>
        <h2 style={{ margin: 0, fontSize: "1.3rem", color: "#0d1b3e" }}>🎓 Matrículas del Estudiante</h2>
        <p style={{ margin: "4px 0 0", color: "#888", fontSize: ".88rem" }}>
          Seleccione un estudiante para ver sus opciones de matrícula.
        </p>
      </div>

      {rows.length === 0 ? (
        <div className="modern-card" style={{ textAlign: "center", padding: 40, color: "#888" }}>
          No hay matrículas disponibles.
        </div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 16 }}>
          {rows.map((row) => (
            <div
              key={row.cod_est}
              className="modern-card"
              style={{
                padding: "20px 24px",
                cursor: "pointer",
                transition: "all 0.25s ease",
                borderLeft: "4px solid #d4a017",
              }}
              onClick={() => {
                const { navigate } = require("@reach/router");
                navigate("search/" + row.cod_est, {
                  state: { nom: row.nom_est, cod: row.cod_est, idIns: row.id_inscripcion },
                });
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 8px 24px rgba(13,27,62,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "";
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <div style={{
                  width: 48, height: 48, borderRadius: "50%",
                  background: "linear-gradient(135deg, #0d1b3e, #1a3068)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: "#d4a017", fontWeight: 800, fontSize: "1rem",
                  flexShrink: 0,
                }}>
                  {row.nom_est ? row.nom_est.charAt(0).toUpperCase() : "?"}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 700, color: "#0d1b3e", fontSize: ".95rem", marginBottom: 2 }}>
                    {row.nom_est}
                  </div>
                  <div style={{ color: "#888", fontSize: ".82rem" }}>
                    Código: <b>{row.cod_est}</b>
                  </div>
                </div>
                <span style={{ color: "#d4a017", fontSize: "1.3rem" }}>→</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
